export default "__VITE_PUBLIC_ASSET__2f8a89ba__"